import type { TerritoryRepository } from '../application/TerritoryRepository'

/** Lecture seule : le repli fixtures reste permis, comme pour les autres verticales. */
export function createResilientTerritoryRepository(
  primary: TerritoryRepository,
  fallback: TerritoryRepository,
): TerritoryRepository {
  return {
    async load() {
      try {
        return await primary.load()
      } catch (error) {
        console.error('Territoire indisponible, repli fixtures.', error)
        return fallback.load()
      }
    },
  }
}
